module.exports = __webpack_public_path__ + "static/media/emika.b602ac2f.svg";